import {Form, Link, useActionData, useLoaderData} from '@remix-run/react'
import {withZod} from '@remix-validated-form/with-zod'
import {z} from 'zod'
import {json} from '@remix-run/node'
import {zfd} from 'zod-form-data'
import {TextInput} from '~/components/Form/TextInput'
import {Button} from '~/components/Button'
import {authenticator} from '~/services/auth.server'
import {commitSession, getUserSession} from '~/services/session.server'
import type {ActionArgs, LoaderArgs} from '@remix-run/node'

export default function PasswordLogin() {
  const {error} = useLoaderData<typeof loader>()
  const actionData = useActionData<typeof action>()
  const fieldErrors = actionData?.error.fieldErrors

  return (
    <div>
      {error && <p className="mb-4 text-red-600">{error.message}</p>}

      <Form
        method="POST"
        className="grid space-y-4 rounded-md bg-white/90 p-4 shadow-2xl backdrop-blur-sm"
      >
        <TextInput
          label="Email address"
          name="email"
          error={fieldErrors?.email}
        />
        <TextInput
          label="Password"
          name="password"
          type="password"
          error={fieldErrors?.password}
        />
        <div className="flex items-center justify-end">
          <Link
            to="/password-reset"
            className="text-sm font-medium text-primary-600 hover:text-primary-500"
          >
            Reset/Set Password
          </Link>
        </div>
        <Button>Sign-in</Button>
      </Form>

      <div className="relative mt-6 px-2 text-center text-sm font-medium text-gray-500">
        Or continue with a{' '}
        <Link to="/login" className="underline">
          login link
        </Link>
      </div>
    </div>
  )
}
